import React from 'react';
//import './Heading.scss'; 
const Heading = ({ level, children, className, id }) => {
  const HeadingTag = `h${level}`;
  return <HeadingTag className={className} id={id}>{children}</HeadingTag>;
};

export default Heading;
